import { User, UserRole, UserRoles } from '../../../config/api/models/User';
import { useAppSelector } from './useAppDispatch';

export const getUserRole = (user: User): UserRole | '' => {
  if (user == null) return '';
  let result = '';

  if (user.roles.includes(UserRoles.STUDENT)) result = UserRoles.STUDENT;
  if (user.roles.includes(UserRoles.TEACHER)) result = UserRoles.TEACHER;
  if (user.roles.includes(UserRoles.AUTHOR)) result = UserRoles.AUTHOR;
  if (user.roles.includes(UserRoles.ADMIN)) result = UserRoles.ADMIN;
  if (user.roles.includes(UserRoles.SUPER_ADMIN)) result = UserRoles.SUPER_ADMIN;

  return result as UserRole | '';
};

export const useUser = () => {
  const user: User | undefined = useAppSelector((state) => state.auth.user);

  return {
    user: user as User,
    isSuperAdmin: user === undefined ? false : (user as User).roles.includes(UserRoles.SUPER_ADMIN),
    isAdmin: user === undefined ? false : (user as User).roles.includes(UserRoles.ADMIN),
    isAuthor: user === undefined ? false : (user as User).roles.includes(UserRoles.AUTHOR),
    isTeacher: user === undefined ? false : (user as User).roles.includes(UserRoles.TEACHER),
    isStudent: user === undefined ? false : (user as User).roles.includes(UserRoles.STUDENT),
    isDeveloper: user === undefined ? false : process.env.REACT_APP_DEVELOPER_LOGIN,
    isImpersonatedUser: user === undefined ? false : user?.isImpersonatedUser,
  };
};
